import { Entity } from './base/entity';

export class WebUser extends Entity {
    id: number;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    address: string;
    cityId: number;
}
